<template>
  <div class="folder-tree w-56 bg-slate-50/50 border-r border-slate-200/60 flex flex-col shrink-0">
    <div class="tree-header px-3 py-2.5 border-b border-slate-200/60 flex items-center justify-between shrink-0 bg-white">
      <span class="text-xs font-semibold text-slate-600 tracking-wide">文件夹</span>
      <el-button
        type="primary"
        text
        size="small"
        class="!w-6 !h-6"
        @click="$emit('create-root')"
        title="新建根文件夹"
      >
        <el-icon class="text-slate-500"><Plus /></el-icon>
      </el-button>
    </div>
    <div class="tree-body flex-1 overflow-y-auto py-1.5 bg-slate-50/50" v-loading="loading">
      <template v-if="treeData.length === 0 && !loading">
        <div class="px-3 py-10 text-center">
          <el-icon :size="32" class="text-slate-300 mb-2 block"><Folder /></el-icon>
          <p class="text-xs text-slate-400">暂无文件夹</p>
          <p class="text-[10px] text-slate-300 mt-1">点击上方 + 新建</p>
        </div>
      </template>
      <template v-else>
        <FolderTreeNode
          v-for="node in treeData"
          :key="node.id"
          :node="node"
          :selected-id="selectedId"
          :depth="0"
          @select="$emit('select', $event)"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
          @move="$emit('move', $event)"
          @acl="$emit('acl', $event)"
          @refresh="$emit('refresh')"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { Plus, Folder } from '@element-plus/icons-vue'
import FolderTreeNode from './FolderTreeNode.vue'

defineProps({
  treeData: { type: Array, default: () => [] },
  selectedId: { type: [Number, String], default: null },
  loading: { type: Boolean, default: false }
})

defineEmits(['select', 'edit', 'delete', 'move', 'acl', 'refresh', 'create-root'])
</script>
